import { warehouseNav } from './warehouse.js';
import { dispatchNav } from './dispatch.js';
const R = 'ready';
export const distributionNav = [
    {
        label: 'Stockists', icon: 'Store', status: R, children: [
            { label: 'All stockists', path: '/field/distributors', module: 'field.distributor', status: R, matchPrefix: true, keywords: 'stockist credit dms' },
            { label: 'What they hold', path: '/field/stock', module: 'field.distributor', status: R, keywords: 'distributor inventory reorder replenishment bucket factory order backorder minimum order value moq shelf' },
            { label: 'Counting their stock', path: '/field/distributor-stock', module: 'field.visit', status: R, keywords: 'closing stock count stockist inventory' },
            { label: 'Logins for shops & stockists', path: '/field/portal-logins', module: 'admin.user', status: R, keywords: 'distributor portal retailer portal login self service app pwa password' },
        ],
    },
    {
        // Booked, loaded, arrived — the three states anybody telephones about,
        // in the order they happen.
        label: 'Getting goods to them', icon: 'Truck', status: R, children: [
            { label: 'Where orders are', path: '/field/order-tracking', module: 'field.order', status: R, keywords: 'tracking dispatch receipt delivered status factory order stockist arrived flow' },
            ...dispatchNav,
        ],
    },
    {
        label: 'What they pay', icon: 'IndianRupee', status: R, children: [
            { label: 'Rates for each product', path: '/field/price-lists', module: 'master.pricelist', status: R, keywords: 'price list rate excel upload import ctn cto discount' },
            { label: 'Price sheets', path: '/field/price-sheets', module: 'master.pricelist', status: R, matchPrefix: true, keywords: 'price list rate card publish distributor retailer mrp scheme' },
        ],
    },
    {
        // The godowns goods are held in and moved between — Morbi to Ahmedabad
        // and back. They sat under a section of their own called "Stock", beside
        // two reports; they belong with the distribution they serve.
        label: 'Godowns', icon: 'Warehouse', status: R, children: [
            ...warehouseNav,
            // 'How much of each product' and 'What the stock is worth' used to sit
            // here, pointing at /reports/stock/*. Those endpoints went when the
            // accounting routes were removed, so both screens asked the server and
            // were answered 404 — and said 'Nothing to show for this view', which
            // reads as an empty godown rather than a broken screen. The warehouse
            // entry above is the one that works, and it has always held more: the
            // batch, the age, the expiry and the value.
        ],
    },
    {
        label: 'Settings', icon: 'Settings2', status: R, children: [
            { label: 'Locking orders', path: '/field/config/distribution', module: 'field.order', status: R, keywords: 'order lock unlock key padlock reopen second factor' },
        ],
    },
];
//# sourceMappingURL=distribution.js.map